
<app-nav-menu></app-nav-menu>
<p-toast></p-toast>
@if (loader) {
  <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500;top:0 ">
    <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%; }">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}

<div style="display:flex;flex-direction:column;">
  <div style="width: 100%; height: 50px; background-color: var(--first-color-second); color: white; display: flex;
       justify-content: center; align-items: center; letter-spacing: 2px">
    <h4>Supplier Passenger Criteria</h4>
  </div>
  <div style="display: flex; justify-content: center; width: 100%; height:0">
    <div class="Triangle">

    </div>
  </div>

</div>


<div style="margin-left:80px;margin-right:80px;margin-top:10px;">

  <form #passCriteriaForm="ngForm" (submit)="SubmitData(passCriteriaForm)"
        style="display: flex; padding:15px;border-radius: 8px; width: 100%; margin-top: 32px; flex-direction: column;
        box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">


    <div>
      <div class="row justify-content-center" style="color:var(--first-color-second);font-size:20px;letter-spacing:2px;
           text-decoration:underline;font-weight:bold;"> Passenger Criteria Detail </div>

      <div class="loop_div">
        <div class="row m-0 pt-2">
          <div class="col-md-3 col-sm-6 mb-4" style="position: relative;">
            <label id="namelabel" [ngClass]="supplierCriteriaSubmission && !supplierPassengerCriteria.name?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">
              Name
            </label>
            <input type="text" [(ngModel)]="supplierPassengerCriteria.name" [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !supplierPassengerCriteria.name}"
              class="inputStyle" required autocomplete="off"
              name="Name" />

              @if (supplierCriteriaSubmission && !supplierPassengerCriteria.name) {
                <span class="inputErrors">
                  **Name Required!
                </span>
              }
            </div>
            <div class="col-md-3 col-sm-6 mb-4" style="position: relative;">

              <p-select class="segmentDropdown" [options]="supplierList" [required]="true" name="supplier"
                [(ngModel)]="supplierPassengerCriteria.supplier" [ngClass]="{'p-dropdown invalid_Prime_Error': supplierCriteriaSubmission && !supplierPassengerCriteria.supplier}"
              placeholder="Select supplier" optionLabel="name" optionValue="supplierId"></p-select>
              <label id="Supplierlabel" [ngClass]="supplierCriteriaSubmission && !supplierPassengerCriteria.supplier?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">
                Supplier
              </label>
              @if (supplierCriteriaSubmission && !supplierPassengerCriteria.supplier) {
                <span class=" inputErrors">
                  **Supplier Required!
                </span>
              }
            </div>


          </div>
        </div>

      </div>

      <hr class="dashed">
      <div style="border-radius: 8px;">

      <div class="row justify-content-center" style="color:var(--first-color-second);font-size:20px;letter-spacing:2px;text-decoration:underline;
           font-weight:bold;"> Airlines </div>
        <div class="row m-0 justify-content-end pr-4">
          <button type="button" class="addnewbtn" (click)="AddAirline()">
            <i class="fas fa-plus-circle"></i> Add Airline
          </button>

        </div>
        @if (addAirlines) {
          <div class=" mt-4">
            @for (airlineobj of supplierPassengerCriteria.byAirlines; track airlineobj; let a = $index) {
              <div id="checking{{a}}" [hidden]="airlineobj.isDeleted" class="flightsdetails mt-4">
                <div class="row m-0">
                  <div class="col-md-6">
                    <label><span style="font-weight:bold;">Airline Sr:</span> {{a + 1}}</label>
                  </div>
                  <div class="col-md-6 ">
                    <div class="row justify-content-end">
                      <a class="card_button-delete" (click)="deleteairline(a)">
                        <i class="uil uil-trash-alt card_button-del"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row m-0 mt-4 ">
                  <div class="col-md-3 col-sm-6 mb-4" style="position: relative;">
                    <label id="namelabel" [ngClass]="supplierCriteriaSubmission && airlineobj.airlines.length==0?'labelofmodifyserachinputsError':'labelofmodifyserachinputs'">
                      Airline
                    </label>
                    <p-multiSelect class="multiselectDropDown" [options]="airlinesList"
                      [(ngModel)]="airlineobj.airlines" [ngClass]="{'p-multiselect invalid_Prime_Error': supplierCriteriaSubmission && airlineobj.airlines.length==0}"
                      placeholder="Select Airlines" optionLabel="airlineLegalName" optionValue="airlinePrefixCode" [required]="true"
                      name="airlines{{a}}" (onChange)="airlinesCheckIfExisit(a)">
                    </p-multiSelect>
                    @if (supplierCriteriaSubmission && airlineobj.airlines.length==0) {
                      <span class=" inputErrors">
                        **Airline Required!
                      </span>
                    }
                  </div>
                  <div style="display:flex;width:100%;justify-content:end;">
                    <span class="inputErrors" style=" margin-right: 12px; margin-top: 14px;"
                    id="valuePercentmessage"></span>
                  </div>
                </div>
                <div class="row m-0 mt-1 ">
                  <div class="row m-0" style="gap:2px">
                    @for (airlinedisplay of airlineobj.airlines; track airlinedisplay; let la = $index) {
                      <div>
                        @for (airlinemastercheck of airlinesList; track airlinemastercheck) {
                          <div>
                            @if (airlinemastercheck.airlinePrefixCode == airlinedisplay) {
                              <div>
                                <p-button severity="warning" label="{{airlinemastercheck.airlineLegalName}}" badge="{{la+1}}"></p-button>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <hr class="dashed">
          <div class="row justify-content-center" style="color:var(--first-color-second);font-size:20px;letter-spacing:2px;text-decoration:underline;
           font-weight:bold;">Criteria to be Applied </div>
                <!--<div class="row m-0 justify-content-end pr-4">
                <button class="addnewbtn" type="button" (click)="AddCriteria(a)">
                  <i class="fas fa-plus-circle"></i>Add Criteria
                </button>
              </div>-->
              <div >
                <div style="border-radius: 8px;" class="flightsdetails mt-4">
                  <div class="row">
                    <div class="col-md-3 ">
                      <div class="mt-2">
                        <input type="checkbox" name="title{{a}}"  [(ngModel)]="airlineobj.title" class="red-input " required [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !airlineobj.title}" style="max-width: 11.5%;" />
                        <label style="margin-left: 10px;" class="headoflabel">Title</label>
                        <br/>
                        @if (supplierCriteriaSubmission && !airlineobj.title) {
                          <span class="inputErrors">
                            **Title Required!
                          </span>
                        }
                      </div>
                    </div>
                    <div class="col-md-3 ">
                      <div class="mt-2">
                        <input type="checkbox" name="firstName{{a}}" [(ngModel)]="airlineobj.firstName" class="red-input " required [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !airlineobj.firstName}" style="max-width: 11.5%;" />
                        <label style="margin-left: 10px;" class="headoflabel">First Name</label>
                        <br />
                        @if (supplierCriteriaSubmission && !airlineobj.firstName) {
                          <span class="inputErrors">
                            **First Name Required!
                          </span>
                        }
                      </div>
                    </div>
                    <div class="col-md-3 ">
                      <div class="mt-2">
                        <input type="checkbox" name="lastName{{a}}" [(ngModel)]="airlineobj.lastName" class="red-input " required [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !airlineobj.lastName}" style="max-width: 11.5%;" />
                        <label style="margin-left: 10px;" class="headoflabel">Last Name</label>
                        <br />
                        @if (supplierCriteriaSubmission && !airlineobj.lastName) {
                          <span class="inputErrors">
                            **Last Name Required!
                          </span>
                        }
                      </div>
                    </div>
                    <div class="col-md-3 ">
                      <div class="mt-2">
                        <input type="checkbox" name="gender{{a}}" [(ngModel)]="airlineobj.gender" class="red-input " required [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !airlineobj.gender}" style="max-width: 11.5%;" />
                        <label style="margin-left: 10px;" class="headoflabel">Gender</label>
                        <br />
                        @if (supplierCriteriaSubmission && !airlineobj.gender) {
                          <span class="inputErrors">
                            **Gender Required!
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="row m-0 justify-content-end pr-4">
                    @if (!airlineobj.showOptionalValues) {
                      <span (click)="ShowOptionalCriteria(a,true)"style="font-size:12px;text-decoration:underline;background:var(--first-color-second);color:white;cursor:pointer;padding:5px;border-radius:4px;border:2px solid var(--first-color-second);font-weight:bold;">Show Optional Criteria</span>
                    }
                    @if (airlineobj.showOptionalValues) {
                      <span (click)="ShowOptionalCriteria(a,false)"style="font-size:12px;text-decoration:underline;background:var(--first-color-second);color:white;cursor:pointer;padding:5px;border-radius:4px;border:2px solid var(--first-color-second);font-weight:bold;">Hide Optional Criteria</span>
                    }
                  </div>
                  @if (airlineobj.showOptionalValues) {
                    <div class="optionalCriteriaValues">
                      <div class="row">
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="passport{{a}}" (change)="onPassportChange(a)" [(ngModel)]="airlineobj.passport" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Passport</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="passportIssueDate{{a}}" [(ngModel)]="airlineobj.passportIssueDate" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Passport IssueDate</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="passportExpiryDate{{a}}" (change)="onPassportExpiryChange(a)" [(ngModel)]="airlineobj.passportExpiryDate" class="red-input" [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !airlineobj.passportExpiryDate}" style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Passport ExpiryDate</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="countryOfIssuance{{a}}" [(ngModel)]="airlineobj.countryOfIssuance" class="red-input" [ngClass]="{'invalid-Error': supplierCriteriaSubmission && !airlineobj.countryOfIssuance}" style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Country Of Issuance</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="dateOfBirth{{a}}" [(ngModel)]="airlineobj.dateOfBirth" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">DateOfBirth</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="nationality{{a}}" [(ngModel)]="airlineobj.nationality" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Nationality</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="age{{a}}" [(ngModel)]="airlineobj.age" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Age</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="frequentFlyerNo{{a}}" [(ngModel)]="airlineobj.frequentFlyerNo" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Frequent FlyerNo</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="email{{a}}" [(ngModel)]="airlineobj.email" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">Email</label>
                          </div>
                        </div>
                        <div class="col-md-3 ">
                          <div class="mt-2">
                            <input type="checkbox" name="phoneNo{{a}}" [(ngModel)]="airlineobj.phoneNo" class="red-input " style="max-width: 11.5%;" />
                            <label style="margin-left: 10px;" class="headoflabel">PhoneNo</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>



    <div class="row m-0 mt-4 mr-2" style="display: flex; justify-content: right;gap:5px">

      <button class="button-iMAGE mr-2" type="submit" id="btnSave">{{namebutton}}</button>
      <button class="cancel_buttons" type="button" id="btnCancel" [routerLink]="['/MasterSupplierPassengerlist']">Cancel</button>

    </div>

  </form>
</div>

